import Style from './style'
import Wrapper from '../Wrapper'

// Mock PrizeSlideshow
const PrizeSlideshowMock = ({prizeList}) => {
	return (
		<Style.PrizeList>
			{prizeList?.map((prize, idx) => (
				<div key={idx}>
					<p>{prize.rank || prize.name}</p>
					<p>{prize.amount || prize.prize}</p>
				</div>
			))}
		</Style.PrizeList>
	)
}

const useResponsiveTimerMock = (wrapperRef) => {
	// Simplified logic, returns default styles or mock responsive calculations
	// In a real port, we'd copy the hook, but for now let's return some safe defaults
	return {
		full: {
			h1: {fontSize: '300px', margin: '40px'},
			h2: {fontSize: '54px'},
			h3: {fontSize: '38px'},
		},
		split: {
			h1: {fontSize: '264px', margin: '30px 0'},
			h2: {fontSize: '42px'},
			h3: {fontSize: '24px'},
		},
	}
}

const Normal = ({
	elapsedTime,
	elapsedTimeDisplay,
	countDown,
	nextBreak,
	regClose,
	timeData,
	prizeData,
	infoData,
	logoImg,
	eventName,
	uploadImage,
	loading,
	eventData,
	wrapperRef,
	navigationBlock,
	setNavigationBlock,
	navigateWithConfirm,
	prize_editor: propPrizeEditor, // Receive the transformed prize_editor from parent
}) => {
	// Mock hooks
	const themeCookie = 'basic'
	const timerStyles = useResponsiveTimerMock(wrapperRef)

	const split = countDown ? countDown?.split(':') : ['00', '00']
	const isWarning = split[0] === '00' && parseInt(split[1]) <= 10 ? true : false
	const {duration, prize_list} = eventData || {}

	// Use the prop if available (it contains the transformed list), otherwise fall back
	const prizeListToUse = propPrizeEditor || eventData?.prize_editor

	return (
		<Wrapper
			title={eventName}
			infoData={infoData}
			logoImg={logoImg}
			timeData={timeData}
			countDown={countDown}
			eventData={eventData}
			prizeData={prizeData}
			prize_editor={prizeListToUse}
			prize_list={prize_list}
			duration={duration}
			ref={wrapperRef}
		>
			<Style.ContentDiv>
				<Style.TimerDiv $themeType={themeCookie}>
					<Style.TimerInfo $warning={isWarning} $timerStyles={timerStyles}>
						<Style.LogoCenter $themeType={themeCookie}>
							{logoImg && <img src={logoImg} alt='logo' />}
						</Style.LogoCenter>
						<Style.TimerTopDiv $themeType={themeCookie}>
							<h1>Level {timeData?.level}</h1>
							<div>
								<h2>Elapsed Time</h2>
								<p>{elapsedTimeDisplay || '00:00'}</p>
							</div>
						</Style.TimerTopDiv>
						<h1>{countDown || '00:00'}</h1>
						<h2>
							BLINDS {timeData?.sb} / {timeData?.bb} ({timeData?.ante})
						</h2>
						{timeData?.next_level === 'break' ? (
							<h3>NEXT BLINDS BREAK TIME</h3>
						) : (
							<h3>
								NEXT BLINDS {timeData?.next_sb} / {timeData?.next_bb} (
								{timeData?.next_ante})
							</h3>
						)}
						<Style.TimerBottomDiv $themeType={themeCookie}>
							<div>
								<h2>Next Break</h2>
								<p>{nextBreak || '00:00'}</p>
							</div>
							<div>
								<h2>Reg. Close</h2>
								<p>{regClose || '00:00'}</p>
							</div>
						</Style.TimerBottomDiv>
						{/* <Style.LogoIcon $themeType={themeCookie} /> */}
					</Style.TimerInfo>
				</Style.TimerDiv>

				<Style.PrizeDiv>
					<Style.PrizeListDiv>
						<h2>Prize Pool</h2>
						<PrizeSlideshowMock prizeList={prizeListToUse || []} />
					</Style.PrizeListDiv>
					{prizeData?.total && (
						<Style.TotlePrizeDiv>
							<h2>Total Prize</h2>
							<p>{prizeData?.total}</p>
						</Style.TotlePrizeDiv>
					)}
				</Style.PrizeDiv>
			</Style.ContentDiv>
		</Wrapper>
	)
}

export default Normal
